import http from './http'
import Loader from './loader'


export default class Favorites {
    constructor (el) {
        this.el = el

        this.loader = new Loader(this.el, '')

        this.el.addEventListener('click', (e) => {
            e.preventDefault()
            this.submitHandler()
        })

    }

    async submitHandler () {
        if (this.el.dataset.loaded) {
            return
        }
        try {
            this.loader.start()
            const data = this.el.dataset
            const response = await http.post(this.action, data)
            if (response.status === 200) {
                this.loader.stop(this.el.dataset.message, true)
                this.el.dataset.loaded = true
            }
        } catch (error) {
            this.loader.error()
        }
    }
}